export const SANITY_PROJECT_ID = '7sua59o5';
export const SANITY_DATASET = 'production';
export const SANITY_API_VERSION = '2021-03-25';
